import {Component, Input, NgModule} from '@angular/core';

@Component({
  selector: 'sd-list, sd-nav-list, sd-action-list, sd-selection-list',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'sd-list block divide-y divide-[var(--m365-border-rest,#ececf0)]'},
})
export class SdList {}

@Component({
  selector: 'sd-list-item, a[sd-list-item], button[sd-list-item]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'sd-list-item flex items-center gap-2 px-3 py-2 text-sm'},
})
export class SdListItem {
  @Input() activated = false;
}

@Component({
  selector: 'sd-list-icon, [sdListIcon]',
  standalone: true,
  template: `<ng-content></ng-content>`,
})
export class SdListIcon {}

@NgModule({
  imports: [SdList, SdListItem, SdListIcon],
  exports: [SdList, SdListItem, SdListIcon],
})
export class SdListModule {}
